define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({

    urlRoot: '/delegate/civics-api/api/cashiering/transactions/',
    url: function() {
      var url;
      if (this.transactionType){
        url = this.urlRoot + this.transactionType;
      }
      else {
        url = this.urlRoot + "completed";
      }
      if ( this.id != undefined && this.id > 1){
        url = url + "/" + this.id;
      }
      return url;
    },
  });
});
